<ng-select class="qv-select standard-scenario-state-select"
  bindLabel="name"
  [appendTo]="appendTo"
  [formControl]="control"
  [items]="selectItems">
</ng-select>
